var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 404,
    viewBox: "0 0 328 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324 403.5H4C2.067 403.5 0.5 401.933 0.5 400V4C0.5 2.067 2.067 0.5 4 0.5H278.424C280.357 0.5 281.924 2.067 281.924 4V39.7735C281.924 42.2588 283.939 44.2735 286.424 44.2735H324C325.933 44.2735 327.5 45.8405 327.5 47.7735V400C327.5 401.933 325.933 403.5 324 403.5Z",
    fill: "url(#paint0_linear_3460_81084)",
    stroke: "#D3DDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328 44.6177H282.997C282.413 44.6177 281.938 44.1838 281.938 43.6485V1.96991L328 44.6177Z",
    fill: "url(#paint1_linear_3460_81084)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 89.0627,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint2_linear_3460_81084)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 136.277,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint3_linear_3460_81084)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 73.3248,
    width: 91.2318,
    height: 7.45486,
    fill: "url(#paint4_linear_3460_81084)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 32.2325,
    width: 91.2318,
    height: 7.45486,
    fill: "url(#paint5_linear_3460_81084)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 104.801,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint6_linear_3460_81084)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 152.015,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint7_linear_3460_81084)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 120.539,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint8_linear_3460_81084)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7549,
    y: 167.753,
    width: 258.49,
    height: 7.45486,
    fill: "url(#paint9_linear_3460_81084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3460_81084",
    x1: 5.43046,
    y1: 8.57547,
    x2: 270.679,
    y2: 436.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214689,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3460_81084",
    x1: 284.556,
    y1: 42.6792,
    x2: 324.858,
    y2: 43.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3460_81084",
    x1: 34.7549,
    y1: 93.2043,
    x2: 309.536,
    y2: 93.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3460_81084",
    x1: 34.7549,
    y1: 140.418,
    x2: 309.536,
    y2: 140.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3460_81084",
    x1: 34.7549,
    y1: 77.4664,
    x2: 131.737,
    y2: 77.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3460_81084",
    x1: 34.7549,
    y1: 36.3741,
    x2: 131.737,
    y2: 36.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3460_81084",
    x1: 34.7549,
    y1: 108.942,
    x2: 309.536,
    y2: 108.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3460_81084",
    x1: 34.7549,
    y1: 156.156,
    x2: 309.536,
    y2: 156.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3460_81084",
    x1: 34.7549,
    y1: 124.68,
    x2: 309.536,
    y2: 124.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3460_81084",
    x1: 34.7549,
    y1: 171.894,
    x2: 309.536,
    y2: 171.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DDEE",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholderIcon);
export default __webpack_public_path__ + "static/media/ThumbnailPlaceholderIcon.07a090a4.svg";
export { ForwardRef as ReactComponent };